import { ISetOwnerParams } from '../types/actionParams';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export class SetDatasourcesOwnerRequest extends Request<ISetOwnerParams, IResult> {
  constructor(ids: string[], ownerId: string) {
    super('setDatasourcesOwner', {
      ids: ids,
      ownerId: ownerId
    });
  }
}
